import React, { useState } from 'react';
import { Col, Row, Button, Checkbox } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { Input } from '@thd-olt-component-react/input';
import { EmailFieldFormatter } from '../FieldFormatter/EmailFieldFormatter';
import constants from '../../constants/constants';
import {
  emailValidator,
  retrieveEmailPreferences,
  unsubscribeFromAllEmailSubscriptions
} from '../../common/sharedFunctions';
import { MobileAwareOverlay } from '../../../components/MobileAwareOverlay';
import { addAnalyticEvent } from '../../analytics/common';
import { confirmOverlay } from '../../analytics/email';

export const UnsubscriptionModal = ({
  handleClose,
  handleSuccess,
  handleError,
  searchedEmail,
}) => {
  const [optOutOfComm, setOptOutOfComm] = useState(false);
  const [emailIfMissing, setEmailIfMissing] = useState('');

  React.useEffect(() => {
    addAnalyticEvent(confirmOverlay);
  }, []);

  const handleDoNotCallClick = () => {
    const actualEmail = searchedEmail || emailIfMissing;

    retrieveEmailPreferences({
      emailAddress: actualEmail,
      callback: (retrieveResponse) => {
        unsubscribeFromAllEmailSubscriptions(
          actualEmail,
          (response) => {
            handleSuccess(actualEmail, response, retrieveResponse);
          },
          (err) => {
            handleError(err);
          }
        );
      },
      err: handleError
    });
  };

  const isEnabledDisabled = () => {
    return optOutOfComm && (searchedEmail || emailValidator(emailIfMissing));
  };

  return (
    <MobileAwareOverlay
      modalClass="preferences-modal"
      onClose={handleClose}
    >
      <Row className="preferences-modal__content">
        <Col md="12" lg="12">
          <h1>Please Confirm Your Unsubscribe Request</h1>
          <Row>
            <Col>
              <Row>
                <Col>
                  <h4>
                    Please enter your e-mail to unsubscribe from all future promotional emails from
                    The Home Depot.<br />To continue, please check the box below:
                  </h4>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  {searchedEmail ? (
                    <Input
                      header="Email Address"
                      type="text"
                      defaultValue={searchedEmail}
                      value={searchedEmail}
                      disabled
                    />
                  ) : (
                    <EmailFieldFormatter callback={setEmailIfMissing} value={emailIfMissing} />
                  )}
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <Checkbox
                    formName="receiveEmailComm"
                    id="receiveEmailComm"
                    onChange={() => setOptOutOfComm(!optOutOfComm)}
                    checked={optOutOfComm}
                    value={optOutOfComm + ''}
                  >
                    {constants.DO_NOT_WANT_EMAILS}
                  </Checkbox>
                  <p style={{ fontSize: '11px',
                    marginLeft: '5%' }}
                  >{constants.TRANSACTIONAL_COMMUNICATION_DISCLAIMER}
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>

          <hr className="hr-line" />
          <Row>
            <Col fallback={8} />
            <Col fallback={4}>
              <Button
                data-testid="doNotCallButton"
                onClick={handleDoNotCallClick}
                disabled={!isEnabledDisabled()}
              >
                Continue
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </MobileAwareOverlay>
  );
};

UnsubscriptionModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSuccess: PropTypes.func.isRequired,
  handleError: PropTypes.func,
  searchedEmail: PropTypes.string,
};

UnsubscriptionModal.defaultProps = {
  searchedEmail: null,
  handleError: () => {},
};
